var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{attrs:{"to":{
    name: 'accounts.accountId.contacts',
    params: {
      accountId: _vm.notification.data.account_id,
    },
  }},scopedSlots:_vm._u([{key:"default",fn:function({ href, navigate }){return [_c('a',{staticClass:"block space-y-1",attrs:{"href":href},on:{"click":navigate}},[_c('div',{staticClass:"text-gray-800",domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('span',{staticClass:"text-xs inline-block text-gray-600"},[_vm._v(" "+_vm._s(_vm.createdAt)+" ")])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }